/** Do not edit directly **/
/** Do not edit directly **/
/**
 * @prop --sy-dismiss-background-color: Dismiss button background color.
 * @prop --sy-dismiss-background-color-hover: Background color on hover / focus.
 * @prop --sy-dismiss-background-color-active: Background color when active.
 * @prop --sy-dismiss-background-color-disabled: Background color when disabled.
 * @prop --sy-dismiss-border-color: Dismiss button border color.
 * @prop --sy-dismiss-border-color-hover: Border color on hover / focus.
 * @prop --sy-dismiss-border-color-active: Border color when active.
 * @prop --sy-dismiss-border-color-disabled: Border color when disabled.
 * @prop --sy-dismiss-border-color-focus-visible: Border color on focus-visible state.
 * @prop --sy-dismiss-border-radius: Dismiss button border radius.
 * @prop --sy-dismiss-color: Dismiss button content color.
 * @prop --sy-dismiss-color-disabled: Content color when disabled.
 * @prop --sy-dismiss-icon-size: Dismiss button default icon size.
 * @prop --sy-dismiss-icon-size-large: Dismiss button large icon size.
 * @prop --sy-dismiss-icon-stroke-width: Dismiss button icon stroke width
 * @prop --sy-dismiss-size: Dismiss default button size.
 * @prop --sy-dismiss-size-large: Dismiss large button size.
 */
*,
:host,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  display: inline-flex;
  --sy-icon-stroke-width: var(--sy-dismiss-icon-stroke-width, 3.5px);
  --sy-button-background-color: var(--sy-dismiss-background-color, transparent);
  --sy-button-border-color: var(--sy-dismiss-border-color, transparent);
  --sy-button-border-color-focus-visible: var(--sy-dismiss-border-color-focus-visible, var(--sy-accent));
  --sy-button-color: var(--sy-dismiss-color, var(--sy-foreground-medium-emphasis));
  --sy-button-icon-color: var(--sy-dismiss-color, var(--sy-foreground-medium-emphasis));
  --sy-button-background-color-active: var(--sy-dismiss-background-color-active, var(--sy-surface-active));
  --sy-button-border-color-active: var(--sy-dismiss-border-color-active, transparent);
  --sy-button-background-color-hover: var(--sy-dismiss-background-color-hover, var(--sy-surface-hover));
  --sy-button-border-color-hover: var(--sy-dismiss-border-color-hover, transparent);
  --sy-button-background-color-disabled: var(--sy-dismiss-background-color-disabled, transparent);
  --sy-button-border-color-disabled: var(--sy-dismiss-border-color-disabled, transparent);
}

:host([disabled]) {
  --sy-button-color-disabled: var(--sy-dismiss-color-disabled, var(--sy-disabled));
  --sy-button-icon-color: var(--sy-dismiss-color-disabled, var(--sy-disabled));
}

.button-dismiss {
  --sy-button-height: var(--sy-dismiss-size, 16px);
  --sy-button-width: var(--sy-dismiss-size, 16px);
  --sy-button-icon-size: var(--sy-dismiss-icon-size, 8px);
}

:host([large]) .button-dismiss {
  --sy-button-height: var(--sy-dismiss-size-large, 32px);
  --sy-button-width: var(--sy-dismiss-size-large, 32px);
  --sy-button-icon-size: var(--sy-dismiss-icon-size-large, 16px);
}